import { FC } from 'react';

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
} from '@/components/ui/Form';
import InstructionHint from '@/components/ui/InstructionHint';
import RadioGroup, { RadioItem } from '@/components/ui/RadioGroup';

import { useLingui } from '@lingui/react';
import { useFormContext } from 'react-hook-form';

export const REPAIRS_BEFORE_ACCIDENT = {
  YES: 'yes',
  NO: 'no',
} as const;

export const REPAIRS_BEFORE_ACCIDENT_NAME = 'repairs_before_accident';
export const REPAIRS_BEFORE_ACCIDENT_NAME_COMPLEMENTARY =
  'repairs_before_accident_complementary';

interface Props {
  name?: string;
  isComplementary?: boolean;
}

export const RadioGroupPreAccidentRepairs: FC<Props> = ({
  name,
  isComplementary = false,
}) => {
  const { i18n } = useLingui();
  const { control } = useFormContext();

  const fieldName =
    name ??
    (isComplementary
      ? REPAIRS_BEFORE_ACCIDENT_NAME_COMPLEMENTARY
      : REPAIRS_BEFORE_ACCIDENT_NAME);

  return (
    <FormField
      control={control}
      name={fieldName}
      rules={{
        required: {
          value: true,
          message: i18n.t('Uzupełnij to pole, aby przejść dalej'),
        },
      }}
      render={({ field }) => (
        <FormItem>
          <FormLabel>
            {i18n.t(
              'Czy samochód miał przed zdarzeniem szkody, które zostały naprawione?'
            )}
          </FormLabel>
          <InstructionHint
            title={
              <span
                dangerouslySetInnerHTML={{
                  __html: i18n.t(
                    'Wybierz odpowiedź <b>Tak</b>, jeśli w pojeździe zostały naprawione szkody z innego, wcześniejszego wypadku.'
                  ),
                }}
              />
            }
          />

          <FormControl>
            <RadioGroup
              {...field}
              layout={'horizontal'}
              data-testid="radio-group-pre-accident-repairs"
            >
              <RadioItem
                value={REPAIRS_BEFORE_ACCIDENT.YES}
                label={i18n.t('Tak')}
                data-testid="radio-item-pre-accident-repairs-yes"
              />
              <RadioItem
                value={REPAIRS_BEFORE_ACCIDENT.NO}
                label={i18n.t('Nie')}
                data-testid="radio-item-pre-accident-repairs-no"
              />
            </RadioGroup>
          </FormControl>
        </FormItem>
      )}
    />
  );
};
